import { LoadingOutlined } from '@ant-design/icons';
import { Button, RadioChangeEvent } from 'antd';
import React, { useEffect } from 'react';
import styles from '../Style/DatasetInfo.module.scss';

export function BuyButton(props: {
  addedToCart: boolean;
  addToCart: () => void;
  removeFromCart: () => void;
  cartLoading: boolean;
  hasDatasets: boolean;
}) {
  return (
    <>
      {props.addedToCart ? (
        <Button
          type="primary"
          className={styles.CartButton}
          onClick={props.removeFromCart}
          loading={props.cartLoading}
          disabled={!props.hasDatasets}
        >
          Remove
        </Button>
      ) : (
        <Button
          type="primary"
          className={styles.CartButton}
          onClick={props.addToCart}
          loading={props.cartLoading}
          disabled={!props.hasDatasets}
        >
          Add to Cart
        </Button>
      )}
    </>
  );
}

export function DownloadButton(props: {
  showCancelDownloadButton: boolean;
  startDownloadProcess: () => void;
  disableDownloadButtons: boolean;
  handleCancelDownload: () => void;
}) {
  return (
    <>
      {!props.showCancelDownloadButton ? (
        <Button
          type="primary"
          className={styles.CartButton}
          onClick={() => props.startDownloadProcess()}
          disabled={props.disableDownloadButtons}
        >
          Download
        </Button>
      ) : (
        <Button
          type="primary"
          danger
          icon={<LoadingOutlined />}
          className={styles.CartButton}
          onClick={() => props.handleCancelDownload()}
        >
          Cancel
        </Button>
      )}
    </>
  );
}
